.tabs__container {
  margin-bottom: var(--qds-main-section-gap-children-unrelated, 1.5rem);
  overflow: hidden;
}
